import { useContext, useState } from 'react';
import { Container, Button, Grid, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';
import { Page } from 'components';


let ForgotPassword = () => {
    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);

    let forgotPasswordSchema = yup.object().shape({
        email: yup.string().default('').required("Email is mandatory"),
    })


    return (
        <Container maxWidth="sm">
            <Page
                useHeader={true}
                isLoading={false}
                title="Forgot your password?"
            >
                <Formik
                    initialValues={forgotPasswordSchema.getDefault()}
                    validationSchema={forgotPasswordSchema}
                    onSubmit={async (values, action) => {
                        setLoading(true);
                        let res = await authService.forgotPassword(values.email);
                        if (res === false) {
                            action.setSubmitting(false);
                            setLoading(false);
                        }
                    }}
                >
                    <Form>
                        <Grid container>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="email"
                                    label="Email"
                                    variant="outlined"
                                    type="email"
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    disabled={isLoading}
                                    startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                >
                                    Send code
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default ForgotPassword;